import React from "react";
import styled from "styled-components";
import { Colors } from "../../../utils/budget-tool-specific";

const Agenda = (props) => {
    return (
        <PageContainer>
            <WideContainer>
                <Row>
                    <Col>
                        <HeaderTitle>
                            Agenda Tool
                        </HeaderTitle>
                        <p>Build and customize your retreat schedule with our interactive agenda planner.</p>
                        <Spacer height="20px" />
                        <IframeContainer>
                            <iframe
                                src="https://moniker-agenda.netlify.app/"
                                title="Moniker Agenda Tool"
                                width="100%"
                                height="1200px"
                                frameBorder="0"
                                allowFullScreen
                                style={{
                                    border: 'none',
                                    borderRadius: '8px',
                                    width: '100%',
                                    display: 'block'
                                }}
                            />
                        </IframeContainer>
                    </Col>
                </Row>
            </WideContainer>
        </PageContainer>
    );
};

export default Agenda;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;

const Spacer = styled.div`
    height: ${props => props.height || '20px'};
`;

const IframeContainer = styled.div`
    background-color: white;
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 100px;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    min-height: 1220px;
`;

const WideContainer = styled.div`
    padding: 0;
    margin: 0;
    width: 100%;
    max-width: 100%;
`;

const HeaderTitle = styled.h2`
    color: ${Colors.primaryDark};
    margin-top: 30px;
    margin-bottom: 0px;
    padding-left: 15px;
`;

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
`;

const Col = styled.div`
    flex: 1;
    padding-right: 15px;
    padding-left: 15px;
`; 